import { zodResolver } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { useQuestionCreationTaskDetails } from '../../providers';
import {
  ChangeDueDateFormModal,
  ChangeDueDateModalSchema,
  type ChangeDueDateModalFormValues,
} from '../change-due-date-form-modal';

interface ChangeDueDateModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ChangeDueDateModal(props: Readonly<ChangeDueDateModalProps>) {
  const { open, onClose } = props;

  const {
    task: { dueDate },
  } = useQuestionCreationTaskDetails();

  const formContext = useForm<ChangeDueDateModalFormValues>({
    resolver: zodResolver(ChangeDueDateModalSchema),
    defaultValues: {
      dueDate: dueDate ? new Date(dueDate) : undefined,
    },
  });

  return (
    <FormProvider {...formContext}>
      <ChangeDueDateFormModal open={open} onClose={onClose} />
    </FormProvider>
  );
}
